import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { pasarACartera } from "./ApiServices";

export default function ModalPasarACartera({ open, onClose, cheque, onOk }) {
  const [idRecibo, setIdRecibo] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setIdRecibo(cheque?.id_recibo != null ? String(cheque.id_recibo) : "");
    setError("");
  }, [open, cheque]);

  const guardar = async () => {
    if (!cheque?.id) return;
    setGuardando(true);
    setError("");
    try {
      const body = {};
      const n = Number(idRecibo);
      if (idRecibo.trim() !== "" && Number.isFinite(n) && n > 0) {
        body.id_recibo = n;
      }
      await pasarACartera(cheque.id, body);
      onOk?.();
      onClose?.();
    } catch (err) {
      setError(err.message || "Error al pasar a cartera");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Dialog open={open} onClose={guardando ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        Pasar a cartera — N° {cheque?.nro_cheque || cheque?.id || ""}
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <Typography variant="body2" color="text.secondary">
            Confirmá que el recibo quedó cargado. Esta acción es un fallback
            de emergencia: el flujo normal es que Finanzas concilie el Excel
            de aceptados del banco.
          </Typography>
          <TextField
            label="ID recibo (opcional)"
            size="small"
            fullWidth
            value={idRecibo}
            onChange={(e) => setIdRecibo(e.target.value.replace(/\D/g, ""))}
            disabled={guardando}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={guardando}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={guardar}
          disabled={guardando}
          startIcon={guardando ? <CircularProgress size={16} color="inherit" /> : null}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
